<template>
    <div>
        <keep-alive v-if="isReady">
            <component :is="this.currentFilterViewComponent" v-bind="currentFiltersComponentProps"></component>
        </keep-alive>
        <div class="ts-finder__layout-map">
            <div ref="map" class="ts-finder__map"></div>
            <markers :google="google" :map="map" />
            <div class="ts-finder__loading-overlay" v-if="!isReady">
                <div>
                    <img :src="loadingLogoUrl" class="ts-finder__loading-logo" /><br />
                    {{strings['TsFinder.Map.Loading']}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import gmapsInit from '../../utils/gmapsInit';
    import FilterPanel from './filters/FilterPanel.vue'
    import SearchBox from './searchbox/SearchBox.vue'
    import Markers from './Markers.vue'
    import { mapActions, mapState } from 'vuex'
    import $ from 'jQuery'

    export default {
        data() {
            return {
                google: null,
                //geocoder: null,
                map: null,
                isReady: false                
            };
        },
        computed: {
            ...mapState([
                'selectedStation',
                'currentFilterViewComponent',
                'userLocation',
                'mapCanonicalLink',
                'strings'
            ]),
            loadingLogoUrl() {
                return window.TS_CONFIG.loadingLogoUrl;
            },
            currentFiltersComponentProps() {
                //this is to pass custom props to dynamic components
                if (this.currentFilterViewComponent === 'search-box') {
                    return { google: this.google, map: this.map };
                }
                return null;
            }
        },
        methods: {
            ...mapActions([
                'loadMapData'
            ]),
            initializeMap() {
                const mapConfig = {
                    zoom: 8,
                    center: {
                        //bern
                        lat: 46.947975,
                        lng: 7.447447
                    },
                    mapTypeId: 'roadmap',
                    clickableIcons: false,
                    fullscreenControl: false,
                    mapTypeControl: false,
                    streetViewControl: false
                };

                const { Map/*, Geocoder*/ } = this.google.maps;
                const mapContainer = this.$refs.map;
                this.map = new Map(mapContainer, mapConfig);
                //this.geocoder = new Geocoder();
            },
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (!vm.isReady) {
                    //if this is the first time this route is called, initialize all data
                    gmapsInit().then(googleObject => {
                        vm.google = googleObject;
                        vm.initializeMap();
                        vm.loadMapData().then(() => {
                            vm.isReady = true;

                            //set canonical link
                            $('link[rel="canonical"]').attr('href', vm.mapCanonicalLink);

                            next();
                        });
                    });
                } else {
                    //just set canonical link
                    $('link[rel="canonical"]').attr('href', vm.mapCanonicalLink);

                    next();
                }
            });
        },
        components: {
            SearchBox,
            FilterPanel,
            Markers
        }
    };
</script>